import { HistoryServiceAckResponse } from '@gtpl/shared-models/masters';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Body, Controller, Post } from '@nestjs/common';
import { ApiTags } from '@nestjs/swagger';
import { PlantIdRequest } from '../unit-codes/dto/plant-id.request';
import { HistoryDTO } from './dto/history.dto';
import { HistoryServiceService } from './history-service.service';

@ApiTags('history-service')
@Controller('history')
export class HistoryServiceController {

    constructor(private historyService: HistoryServiceService,
        private readonly applicationExceptionHandler: ApplicationExceptionHandler) { }

        
    /**
     * calling a service to create a new history record
     * @param historyDto 
     * @returns 
     */
    @Post('/createHistory')
    async createHistory(@Body() historyDto: HistoryDTO): Promise<HistoryServiceAckResponse>  {
        try {
        return await this.historyService.createHistory(historyDto);
        } catch (error) {
        return this.applicationExceptionHandler.returnException(HistoryServiceAckResponse, error);
        }
    }

    /**
     * calling a service to get hisotry
     * @returns 
     */
    @Post('getHistory')
    async getHistory():Promise<HistoryServiceAckResponse> {
        try {
        return await this.historyService.getHistory();
        } catch (error) {
        return this.applicationExceptionHandler.returnException(HistoryServiceAckResponse, error);
        }
    }

    /**
     * calling a service to get hisotry
     * @param plantIdReq
     * @returns 
     */
     @Post('getHistoryByPlantId')
     async getHistoryByPlantId(@Body() plantIdReq: PlantIdRequest):Promise<HistoryServiceAckResponse> {
         try {
         return await this.historyService.getHistoryByPlantId(plantIdReq);
         } catch (error) {
         return this.applicationExceptionHandler.returnException(HistoryServiceAckResponse, error);
         }
     }
}
